import React from "react";

import { DateTime } from "@bps/date-time";
import {
  MessageBar,
  MessageBarType,
  NoDataTile,
  Stack,
  Text,
  Link,
  useTheme
} from "@bps/fluent-ui";
import { BulkActionResponse } from "@libs/api/gateways/field/field-ops-gateway.dtos";
import { config } from "@libs/config/config";
export interface BulkActionResultProps {
  response?: BulkActionResponse;
}

export const BulkActionResult: React.FC<BulkActionResultProps> = ({
  response
}) => {
  const theme = useTheme();
  const correlationId = response?.correlationId ?? "null";

  return (
    <Stack
      tokens={{ childrenGap: theme.spacing.s1 }}
      styles={{
        root: {
          borderColor: theme.semanticColors.variantBorder,
          borderWidth: 1,
          borderStyle: "solid",
          padding: theme.spacing.s1,
          minHeight: 100,
          width: "50%",
          minWidth: 500
        }
      }}
    >
      <Stack
        horizontal
        styles={{
          root: {
            alignItems: "end",
            justifyContent: "space-between"
          }
        }}
      >
        <Text variant="xLarge" styles={{ root: { minWidth: 190 } }}>
          Bulk Action Result
        </Text>

        {response && (
          <Text variant="xSmall">{DateTime.now().toFormat("FFFF")}</Text>
        )}
      </Stack>

      {response ? (
        <MessageBar messageBarType={MessageBarType.success}>
          <Stack
            styles={{
              root: { width: "100%" }
            }}
            tokens={{ childrenGap: theme.spacing.l2 }}
            horizontal
          >
            <Stack>
              <Text>
                <b>CorrelationId:</b>

                {correlationId ? (
                  <Link
                    href={`${config.seqUrl}?range=1d&filter="${correlationId}"`}
                    target="_blank"
                  >
                    {correlationId}
                  </Link>
                ) : (
                  "null"
                )}
              </Text>
              <Text>
                <b>Device Count:</b> {response.deviceCount ?? "null"}
              </Text>
            </Stack>

            <Stack
              styles={{
                root: { minWidth: 130 }
              }}
            >
              <Text>
                <b>Error Count:</b> {response.errorCount ?? "null"}
              </Text>
              <Text>
                <b>Processed Count:</b> {response.processedCount ?? "null"}
              </Text>
            </Stack>
          </Stack>
        </MessageBar>
      ) : (
        <NoDataTile
          textProps={{ text: "No bulk action result" }}
          styles={{ root: { minHeight: 50 } }}
          showBoxShadow={false}
          linkProps={{}}
        />
      )}
    </Stack>
  );
};
